// Defensive guard for rare Bootstrap modal race conditions in SPA navigation.
// In Blazor, the DOM can be replaced while a Bootstrap modal transition callback is still running.
// This can surface as "Cannot read properties of null (reading 'style')" from modal.js/_hideModal.

(function () {
  function looksLikeBootstrapModalHideNullStyle(err) {
    const msg = (err && (err.message || err.toString())) || '';
    if (!msg) return false;

    // Match common variants across browsers/bundles.
    return (
      msg.includes("Cannot read properties of null") && msg.includes("style") && (msg.includes("modal") || msg.includes("_hideModal"))
    ) || (
      msg.includes("Cannot read property 'style' of null") && (msg.includes("modal") || msg.includes("_hideModal"))
    );
  }

  function safeCleanupArtifacts() {
    try {
      if (window.bootstrapModalCleanup && typeof window.bootstrapModalCleanup.cleanupModalArtifacts === 'function') {
        window.bootstrapModalCleanup.cleanupModalArtifacts();
      }
    } catch {
      // ignore
    }
  }

  window.addEventListener('error', (e) => {
    const err = e?.error || e;
    if (!looksLikeBootstrapModalHideNullStyle(err)) {
      return;
    }

    // Prevent the error from surfacing as an unhandled exception.
    try { e.preventDefault?.(); } catch { /* ignore */ }

    // Best-effort cleanup so the UI isn't left stuck.
    safeCleanupArtifacts();
  });

  window.addEventListener('unhandledrejection', (e) => {
    const err = e?.reason;
    if (!looksLikeBootstrapModalHideNullStyle(err)) {
      return;
    }

    try { e.preventDefault?.(); } catch { /* ignore */ }
    safeCleanupArtifacts();
  });
})();
